module.exports = __webpack_public_path__ + "static/media/line-app.414687b5.png";